var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64982 0.350185C9.1829 -0.116728 8.42589 -0.116728 7.95897 0.350185L5 3.30916L2.04103 0.350185C1.57411 -0.116728 0.817098 -0.116728 0.350185 0.350185C-0.116728 0.817098 -0.116728 1.57411 0.350185 2.04103L3.30916 5L0.350185 7.95897C-0.116728 8.42589 -0.116728 9.1829 0.350185 9.64982C0.817098 10.1167 1.57411 10.1167 2.04103 9.64982L5 6.69084L7.95897 9.64982C8.42589 10.1167 9.1829 10.1167 9.64982 9.64982C10.1167 9.1829 10.1167 8.42589 9.64982 7.95897L6.69084 5L9.64982 2.04103C10.1167 1.57411 10.1167 0.817098 9.64982 0.350185Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallClose);
export default __webpack_public_path__ + "static/media/small_close.86a9199a985c9224d0608e0960456fd0.svg";
export { ForwardRef as ReactComponent };